import { View } from "binder"
import { ToolStatusEditorViewModel } from "./toolStatusEditor-viewModel"

export class ToolStatusEditorView extends View<ToolStatusEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-6C029D4E-3219-4A0D-B43C-639852F965AD"
    }
    loadHtml(): string {
        let element = require('./toolStatusEditor.html').default;
        let style = require('./toolStatusEditor.less');
        return element;
    }
    constructor() {
        super();
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set force(v: boolean) { this._force = v; } public get force(): boolean { return this._force; } private _force: boolean;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    back() {
        this.dataContext.back();
    }

    save() {
        this.dataContext.save();
    }
}
